/* AI 자유대화 빠른 음성 응답 — 2026-09-30 (OWNER '1초 안에 답변 나오게')
 *
 * 실측(운영, 2026-09-30): 학생 말이 끝난 뒤 피아 첫 소리까지 약 4초.
 *   AI 답 전체 1.0~1.5초 → 답 전체를 한 번에 음성 합성 2.5~2.9초 → 재생.
 * 바꾼 것(이 파일):
 *   1) 즉시 맞장구 — 음성으로 답한 차례면 보내는 순간 짧은 "음," "응," 을 미리 받아 둔 소리로
 *      바로 낸다(약 0.1초). 생각하는 동안 말이 없는 공백을 없앤다.
 *   2) 첫 문장 먼저 — AI 답이 흘러 들어오는 중 첫 문장이 끝나면 그 문장만 바로 합성·재생한다.
 *      나머지는 답이 확정되면 미리 합성해 두었다가 첫 문장이 끝나는 즉시 잇는다.
 *      확정된 답이 첫 문장과 다르면(재생성 등) 첫 문장을 끊고 확정 답 전체를 읽는다.
 *   3) 서버(routes/tts.mjs)는 Google 이 바로 만든 Ogg/Opus 를 보낸다(ffmpeg 두 번 생략, 별도 변경).
 * 연결: pia-main.js 스트리밍 루프가 window.__piaEarlyDelta(acc) 를 부른다.
 *       kiosk.js 가 window.__piaTtsUrl·__piaTtsChunks 를 내보낸다(미리 합성용).
 *       window.speakReply·piaStopSpeak 를 감싼다(다른 파일은 고치지 않음).
 * 끄기: localStorage 'pia_fastvoice' = '0'.
 * 말하기 속도: 화면 선택값을 서버 음성에도 적용(아래 '말하기 속도').
 */
(function () {
  'use strict';
  if (window.__piaFastVoice) return;
  window.__piaFastVoice = 1;

  function off() { try { return localStorage.getItem('pia_fastvoice') === '0'; } catch (e) { return false; } }
  function el(id) { return document.getElementById(id); }
  function onChat() {
    try { var s = document.querySelector('section[data-view]:not(.hidden)'); return !!s && s.dataset.view === 'chat'; } catch (e) { return false; }
  }
  function ttsOn() {
    if (typeof window.piaSpeak !== 'function') return false;
    var cb = el('chat-tts'); if (cb && !cb.checked) return false;
    try { if (localStorage.getItem('pia_tts') === '0') return false; } catch (e) {}
    return true;
  }
  function voiceTurn() { try { return !!(window.piaBargeIn && window.piaBargeIn.state().voiceTurn); } catch (e) { return false; } }
  function isEn() { return window.aipiaCurrentLang === 'en'; }
  function norm(s) { return String(s || '').replace(/[\s.,!?~…·'"“”‘’()\-]/g, ''); }
  function log() { try { console.log.apply(console, ['[fastvoice]'].concat([].slice.call(arguments))); } catch (e) {} }

  /* ── 1) 즉시 맞장구 ───────────────────────────────────── */
  /* 2026-10-01 OWNER '음... 이런거 제거' — '음,'·'Hmm,' 뺌 */
  var FILL = { ko: ['응,', '아하,'], en: ['Okay,', 'I see,'] };
  var fillCache = {}, fillLast = -1, fillAudio = null;
  function fillUrl(t) { try { return typeof window.__piaTtsUrl === 'function' ? window.__piaTtsUrl(t) : ''; } catch (e) { return ''; } }
  function preloadFill() {
    if (off() || !ttsOn()) return;
    var list = FILL[isEn() ? 'en' : 'ko'];
    for (var i = 0; i < list.length; i++) {
      var u = fillUrl(list[i]); if (!u || fillCache[u]) continue;
      try {
        var A = window.__OrigAudio || window.Audio;
        var a = new A(); a.preload = 'auto'; a.src = u; fillCache[u] = a;
      } catch (e) { console.error('[fastvoice] 맞장구 준비 실패', e); }
    }
  }
  function playFill() {
    var list = FILL[isEn() ? 'en' : 'ko'];
    var k = Math.floor(Math.random() * list.length); if (k === fillLast) k = (k + 1) % list.length; fillLast = k;
    var a = fillCache[fillUrl(list[k])];
    if (!a) return;
    try { a.currentTime = 0; var p = a.play(); if (p && p.catch) p.catch(function () {}); fillAudio = a; } catch (e) {}
  }
  function stopFill() { try { if (fillAudio) { fillAudio.pause(); fillAudio = null; } } catch (e) {} }

  /* ── 차례 상태 ────────────────────────────────────────── */
  var turn = null;      /* 지금 보내는 중인 차례 */
  var active = null;    /* 첫 문장을 이미 말하기 시작한 차례(나머지 대기 포함) */

  function startTurn() {
    if (off()) { turn = null; return; }
    turn = { voice: voiceTurn(), spoken: '', firstDone: false, pendingRest: null, cancelled: false, t0: Date.now() };
    try { var qi = el('chat-input'); turn.q = qi ? String(qi.value || '') : ''; } catch (e) { turn.q = ''; }   /* send() 가 입력칸을 비우기 전 */
    turn.lat = { at: new Date().toISOString(), voice: turn.voice, filler: null, firstDelta: null, firstAudio: null, early: false };
    if (turn.voice && ttsOn() && onChat()) { playFill(); turn.lat.filler = Date.now() - turn.t0; }
  }

  /* send() 가 window.__piaSending = true/false 로 차례 시작·끝을 표시한다 → 접근자로 감지 */
  try {
    var sending = !!window.__piaSending;
    Object.defineProperty(window, '__piaSending', {
      configurable: true,
      get: function () { return sending; },
      set: function (v) { var prev = sending; sending = !!v; if (!prev && sending) startTurn(); }
    });
  } catch (e) { console.error('[fastvoice] 전송 감시 설치 실패', e); }

  /* ── 지연 기록 — 실기기에서 '말 끝 → 첫 소리'를 재기 위한 것(내용은 담지 않는다) ──
     window.piaLatency: 최근 30차례 [{at, voice, filler, firstDelta, firstAudio, early}] (ms, 전송 시각 기준).
     콘솔 '[fastvoice] 첫 소리 …ms' 로도 남긴다. */
  window.piaLatency = window.piaLatency || [];
  function markAudio(t) {
    if (!t || !t.lat || t.lat.firstAudio != null) return;
    t.lat.firstAudio = Date.now() - t.t0;
    window.piaLatency.push(t.lat); if (window.piaLatency.length > 30) window.piaLatency.shift();
    log('첫 소리', t.lat.firstAudio + 'ms', '(맞장구 ' + t.lat.filler + 'ms · 첫 글자 ' + t.lat.firstDelta + 'ms · 첫 문장 먼저 ' + t.lat.early + ')');
  }

  /* ── 따라 말하기 빼기(2026-10-01 OWNER '질문한 말을 답변에서 다시 이야기 해주는데 그건 뺐으면') ──
     지시문으로 막아도 모델(Flash-Lite)이 '강아지랑 산책했구나!'처럼 학생 말을 되받는 첫 문장을 자주 만든다
     (실측 16건 중 5~7건). 첫 문장이 학생 말을 되풀이한 것이면 빼고 다음 문장부터 쓴다.
     되풀이 판정: ① 학생 말 2글자 묶음의 절반 이상(또는 낱말 줄기의 60% 이상)이 들어 있고 '…구나/…네요/…다니'로 끝남, 또는
                 ② 첫 문장 2글자 묶음의 70% 이상이 학생 말에 있음(예: '와, 게임 개발자!').
     뒤에 남는 문장이 없으면 그대로 둔다. 끄기: localStorage 'pia_noecho'='0'.
     pia-main(확정 답)과 이 파일(첫 문장 먼저)이 같은 판정을 쓴다 → 먼저 읽은 문장과 확정 답이 어긋나지 않는다. */
  function bi(s) { var n = norm(s), o = []; for (var i = 0; i < n.length - 1; i++) o.push(n.substr(i, 2)); return o; }
  function isParrot(sent, q) {
    var qs = norm(q), ss = norm(sent);
    if (qs.length < 3 || ss.length < 2) return false;
    var qb = bi(q), sb = bi(sent), hq = 0, hs = 0, i;
    if (!qb.length || !sb.length) return false;
    for (i = 0; i < qb.length; i++) if (ss.indexOf(qb[i]) >= 0) hq++;
    for (i = 0; i < sb.length; i++) if (qs.indexOf(sb[i]) >= 0) hs++;
    /* 활용형이 바뀌면(좋아해→좋아하는구나) 2글자 묶음이 덜 겹친다 → 학생 말 낱말의 앞 두 글자(줄기)가 얼마나 들어 있는지도 본다 */
    var stems = String(q).split(/\s+/).map(function (w) { return norm(w); }).filter(function (w) { return w.length >= 2; }).map(function (w) { return w.slice(0, 2); });
    var st = 0; for (i = 0; i < stems.length; i++) if (ss.indexOf(stems[i]) >= 0) st++;
    var stemRatio = stems.length ? st / stems.length : 0;
    var echoEnd = /(구나|군요|네요|다니|구먼)[\s!.~?…]*$/.test(String(sent).trim());
    return ((hq / qb.length >= 0.5 || stemRatio >= 0.6) && echoEnd) || (hs / sb.length >= 0.7);
  }
  function sentences(t) { return String(t || '').match(/[^.!?…]+[.!?…]*\s*/g) || []; }
  function noEchoOff() { try { return localStorage.getItem('pia_noecho') === '0'; } catch (e) { return false; } }
  window.piaStripEcho = function (text, q) {
    try {
      if (noEchoOff() || !q) return text;
      var ss = sentences(text);
      if (ss.length < 2 || !isParrot(ss[0], q)) return text;
      var rest = ss.slice(1).join('').trim();
      return rest || text;
    } catch (e) { console.error('[fastvoice] 따라 말하기 정리 실패', e); return text; }
  };

  /* ── 2) 첫 문장 먼저 ──────────────────────────────────── */
  var FIRST_MIN = 6;   /* 첫 덩어리 최소 글자(공백·부호 제외) — "와!" 같은 감탄만으로는 끊지 않는다 */
  function firstChunk(acc) {
    var re = /[.!?…]+(?=\s)/g, m;
    while ((m = re.exec(acc))) {
      var s = acc.slice(0, m.index + m[0].length).trim();
      if (norm(s).length >= FIRST_MIN) return s;
    }
    return '';
  }
  window.__piaEarlyDelta = function (acc) {
    var t = turn;
    if (t && t.lat && t.lat.firstDelta == null) t.lat.firstDelta = Date.now() - t.t0;
    if (!t || t.spoken || t.cancelled || off() || !ttsOn() || !onChat()) return;
    /* 확정 답은 canonicalChatReply(pia-main)가 '아이고…' 감탄을 지운다. 예전엔 그런 답이면 첫 문장 먼저를
       아예 건너뛰어 답의 약 1/4 이 느려졌다(2026-10-01 실측 16건 중 4건). 같은 규칙으로 지우고 진행한다. */
    var a = String(acc || '').replace(/\uC544\uC774\uACE0[\uC57C\uC544]?[\s!,.~]*/gi, '').replace(/(^|[\s.!?])(?:으?음+|흠+|어+)(?:\.{2,}|…|[,~!]|\s)+/g, '$1').replace(/^[\s,!.~]+/, '');   /* canonicalChatReply 와 같은 정리 */
    /* 첫 문장이 학생 말 되풀이면 건너뛰고 다음 문장을 먼저 읽는다(확정 답도 pia-main 에서 같은 규칙으로 뺀다) */
    if (!t.echoChecked && t.q && !noEchoOff()) { var s0 = firstChunk(a); if (!s0) return; t.echoChecked = true; if (isParrot(s0, t.q)) t.skip = s0; }
    if (t.skip) { var k = a.indexOf(t.skip); a = k >= 0 ? a.slice(k + t.skip.length).replace(/^[\s,!.~]+/, '') : a; }
    var s = firstChunk(a);
    if (!s) return;
    t.spoken = s; active = t;
    stopFill();
    log('첫 문장', (Date.now() - t.t0) + 'ms', s.length + '자');
    try { window.__piaLastSpokenText = s; } catch (e) {}
    if (t.lat) t.lat.early = true;
    window.piaSpeak(s, function () { markAudio(t); }, function () {
      t.firstDone = true;
      if (t.pendingRest && !t.cancelled) { var r = t.pendingRest; t.pendingRest = null; window.piaSpeak(r); }
      else if (!t.pendingRest && t === active && t.restSet) active = null;
    });
  };

  function restAfter(full, spoken) {
    var need = norm(spoken).length, got = 0, i = 0;
    for (; i < full.length && got < need; i++) { if (norm(full[i])) got++; }
    return full.slice(i).replace(/^[\s.,!?~…·'"”’)]+/, '').trim();
  }
  function prefetch(text) {
    try {
      if (typeof window.__piaTtsUrl !== 'function' || typeof window.__piaTtsChunks !== 'function') return;
      var ch = window.__piaTtsChunks(text) || [];
      for (var i = 0; i < ch.length; i++) fetch(window.__piaTtsUrl(ch[i]), { credentials: 'omit' }).catch(function () {});
    } catch (e) { console.error('[fastvoice] 미리 합성 실패', e); }
  }

  /* ── 확정 답 낭독(speakReply) 감싸기 ───────────────────── */
  function wrapSpeakReply() {
    var orig = window.speakReply;
    if (typeof orig !== 'function' || orig.__fast) return false;
    var w = function (text) {
      var t = turn; turn = null;
      if (!t || !t.spoken || t.cancelled || off()) {
        /* 첫 문장 먼저를 못 탄 차례도 첫 소리 시각은 남긴다 — 같은 서버 음성 경로로 직접 읽는다 */
        if (t && !t.cancelled && t.lat && ttsOn() && !(el('chat-tts') && !el('chat-tts').checked)) {
          try { window.piaSpeak(String(text == null ? '' : text), function () { markAudio(t); }); return; } catch (e) { console.error('[fastvoice] 낭독 실패', e); }
        }
        return orig.apply(this, arguments);
      }
      var full = String(text == null ? '' : text);
      var cb = el('chat-tts'); if (cb && !cb.checked) return;
      if (norm(full).indexOf(norm(t.spoken)) !== 0) {      /* 답이 바뀌었다 → 확정 답 전체 */
        log('답 변경 — 전체 다시 읽기');
        active = null;
        return orig.apply(this, arguments);
      }
      try { window.__piaLastSpokenText = full; } catch (e) {}
      var rest = restAfter(full, t.spoken);
      t.restSet = true;
      if (!rest) return;
      prefetch(rest);
      if (t.firstDone) { if (!t.cancelled) window.piaSpeak(rest); }
      else t.pendingRest = rest;
    };
    w.__fast = true;
    window.speakReply = w;
    return true;
  }
  function wrapStop() {
    var os = window.piaStopSpeak;
    if (typeof os !== 'function' || os.__fast) return false;
    var w = function () {
      if (turn) turn.cancelled = true;
      if (active) { active.cancelled = true; active.pendingRest = null; active = null; }
      stopFill();
      return os.apply(this, arguments);
    };
    w.__fast = true;
    window.piaStopSpeak = w;
    return true;
  }
  /* pia-stable-full-tts.js 등이 나중에 다시 대입할 수 있어 몇 번 더 확인한다 */
  var tries = 0;
  (function ensure() {
    wrapSpeakReply(); wrapStop();
    if (++tries < 12) setTimeout(ensure, 500);
  })();

  /* 대화 화면에 들어오면 맞장구 소리를 미리 받아 둔다 */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('#chat-mic, #mv-start-voice, #chat-send') : null;
    if (t) preloadFill();
  }, true);

  /* ── 말하기 속도(2026-10-01 OWNER '대화 속도를 빠르게') ──────────
     화면의 속도 선택(#chat-speed-ui, localStorage pia_tts_speed)은 브라우저 내장 음성에만 쓰이고,
     실제로 나오는 서버 음성(kiosk.js speed())은 PIA 에서 늘 0.85 로 고정이라 선택이 먹지 않았다.
     kiosk.js speed() 가 먼저 보는 window.TTS_SPEED 를 선택값에 맞춰 둔다(이 파일은 AI PIA 에만 실림).
     빠르게(기본) 1.15 · 보통 1.0 · 느리게 0.85(예전 값).
     2026-10-01 추가: 더 빠르게 1.25 · 아주 빠르게 1.5 (Google speakingRate 0.25~4 범위 안). */
  var RATE = { slow: 0.85, normal: 1.0, fast: 1.15, x125: 1.25, x150: 1.5 };
  function applyRate() {
    var v = 'fast'; try { v = localStorage.getItem('pia_tts_speed') || 'fast'; } catch (e) {}
    window.TTS_SPEED = RATE[v] || RATE.fast;
  }
  applyRate();
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.id === 'chat-speed-ui') setTimeout(function () { applyRate(); fillCache = {}; preloadFill(); }, 0);
  }, true);

  window.piaFastVoice = { rate: function () { return window.TTS_SPEED; }, state: function () { return { turn: turn && { voice: turn.voice, spoken: turn.spoken }, active: !!active, off: off() }; } };
})();
